<template>
    <el-row>
        <table-template :queryParams="queryParams" actionUrl="/clueCity/findMyClueCityList.action"
                        ref="clueCityTable">
            <template slot="search">
                <el-select @change="onStatusChange" clearable placeholder="状态" style="margin-left:5px;"
                           v-model="queryParams.del">
                    <el-option :value="2" label="启用"></el-option>
                    <el-option :value="1" label="未启用"></el-option>
                </el-select>

                <el-input v-model="queryParams.keyWord" style="margin-left:10px;width:230px;" placeholder="城市"></el-input>
                <el-button style="margin-left:10px;" type="primary" @click="$refs['clueCityTable'].search()">搜索</el-button>

            </template>
            <template slot="item">
                <el-table-column
                    label="城市"
                    prop="city">
                <template scope="scope">
                    {{scope.row.city}}
                </template>
            </el-table-column>

                <el-table-column
                        label="访问路径"
                        prop="emName">
                    <template scope="scope">
                        {{scope.row.visitUrl}}
                    </template>
                </el-table-column>


                <el-table-column
                        label="启用状态"
                        prop="del">
                    <template scope="scope">
                <span style="color:#fcb205" v-if="scope.row.del == 2">
                         启用
                  </span>
                        <span  v-if="scope.row.del == 1 ">
                        未启用
                  </span>
                    </template>
                </el-table-column>
                <el-table-column
                        label="操作">
                    <template scope="scope">

                        <el-button :confirm-data="{id:scope.row.id,del:scope.row.del==1?2:1}" :style="{color:scope.row.del==1?'#f56c6c':'#67c23a'}" @onConfirm="$refs['clueCityTable'].search()"
                                   :confirm-text="scope.row.del==1?'启用':'暂停'" requestUrl="clueCity/changeStatus.action"
                                   type="text"
                                   v-confirm>{{scope.row.del==1?'启用':'暂停'}}
                        </el-button>
                    </template>
                </el-table-column>
            </template>
        </table-template>
    </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'


export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'clueCityList',
  data: function () {
    return {

      queryParams: {
        startTime: null,
        endTime: null
      }
    }
  },
  methods: {
    onStatusChange: function (value) {
      this.queryParams.del = value
      this.$refs['clueCityTable'].search()
    }
  },
  filters: {

  }
}
</script>

<style scoped>

</style>
